(function () {
  'use strict';

  var MONTHS = ['January','February','March','April','May','June','July',
    'August','September','October','November','December'];
  var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var DEFAULT_SETTINGS = {
    timezone: 'Asia/Dubai',
    cutoffHour: 10,
    weekendDays: [0]
  };
  var MAX_DELIVERY_DAYS = 60;
  // Searching further than this for a dispatch or delivery day means every day is closed.
  var MAX_SCAN_DAYS = 400;

  // Calendar dates are handled as whole days since 1970-01-01 (UTC), so neither the
  // store's nor the shopper's daylight-saving changes can move a date.
  function dayNumber(year, monthIndex, day) {
    return Math.round(Date.UTC(year, monthIndex, day) / 86400000);
  }
  function weekday(dayNum) {
    return (((dayNum + 4) % 7) + 7) % 7;
  }
  function dayParts(dayNum) {
    var d = new Date(dayNum * 86400000);
    return { year: d.getUTCFullYear(), month: d.getUTCMonth(), day: d.getUTCDate() };
  }
  function toLocalDate(dayNum) {
    var p = dayParts(dayNum);
    return new Date(p.year, p.month, p.day);
  }
  function partsFromDate(d) {
    return {
      year: d.getFullYear(), month: d.getMonth(), day: d.getDate(),
      hour: d.getHours(), minute: d.getMinutes()
    };
  }

  function parseOverride(str) {
    if (!str) return null;
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(str).trim());
    if (!m) return null;
    var d = new Date(+m[1], +m[2] - 1, +m[3]);
    return isNaN(d.getTime()) ? null : d;
  }
  function parseDateDay(str) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str);
    if (!m) return null;
    var dayNum = dayNumber(+m[1], +m[2] - 1, +m[3]);
    var p = dayParts(dayNum);
    // Reject dates that rolled over, such as 2026-02-30.
    return p.year === +m[1] && p.month === +m[2] - 1 && p.day === +m[3] ? dayNum : null;
  }
  function validTimeZone(value) {
    if (typeof value !== 'string' || !value) return null;
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: value });
      return value;
    } catch (e) {
      return null;
    }
  }
  function parseCutoffHour(value) {
    if (typeof value === 'number') {
      return Number.isInteger(value) && value >= 0 && value <= 23 ? value : null;
    }
    if (typeof value !== 'string' || !/^(?:[0-9]|1[0-9]|2[0-3])$/.test(value)) return null;
    return +value;
  }
  // 'HH:MM' (24-hour) to minutes after midnight.
  function parseTime(value) {
    if (typeof value === 'number') {
      return Number.isInteger(value) && value >= 0 && value < 1440 ? value : null;
    }
    if (typeof value !== 'string') return null;
    var m = /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/.exec(value.trim());
    return m ? +m[1] * 60 + +m[2] : null;
  }
  // A JavaScript day index (Sunday = 0), or a day name such as 'Sat' or 'Saturday'.
  function parseDay(value) {
    if (typeof value === 'number') {
      return Number.isInteger(value) && value >= 0 && value <= 6 ? value : null;
    }
    if (typeof value !== 'string') return null;
    var token = value.trim().toLowerCase();
    if (/^[0-6]$/.test(token)) return +token;
    for (var i = 0; i < DAYS.length; i++) {
      var name = DAYS[i].toLowerCase();
      if (token === name || token === name.slice(0, 3)) return i;
    }
    return null;
  }
  function parseWeekendDays(value) {
    var days;
    if (Array.isArray(value)) {
      days = value.slice();
    } else if (typeof value === 'string') {
      if (!value) return null;
      days = value.split(',');
    } else {
      return null;
    }
    if (!days.length) return null;
    for (var i = 0; i < days.length; i++) {
      var day = parseDay(days[i]);
      if (day === null) return null;
      days[i] = day;
    }
    return days;
  }
  // 'Sat 13:30, Fri 12:00' (or ';'-separated, or 'Sat: 13:30') to { 6: 810, 5: 720 }.
  // Empty entries are skipped. Returns false when any other entry can't be read, so a typo
  // withholds the estimate instead of quietly using the wrong cutoff.
  function parseDayCutoffs(value) {
    if (value && typeof value === 'object' && !Array.isArray(value)) return value;
    if (typeof value !== 'string' || !value.trim()) return null;
    var cutoffs = {};
    var found = false;
    var entries = value.split(/[,;]/);
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].trim()) continue;
      // A numeric day needs a separator after it, so a bare '13:30' is not day 1 at 3:30.
      var m = /^\s*([A-Za-z]+|[0-6](?=\s*[:=\s]))\s*[:=]?\s*(\d{1,2}:\d{2})\s*$/.exec(entries[i]);
      var day = m ? parseDay(m[1]) : null;
      var minutes = m ? parseTime(m[2]) : null;
      if (day === null || minutes === null) return false;
      cutoffs[day] = minutes;
      found = true;
    }
    return found ? cutoffs : null;
  }
  function parseDeliveryDays(value) {
    if (typeof value === 'number') {
      return Number.isInteger(value) && value >= 0 && value <= MAX_DELIVERY_DAYS ? value : null;
    }
    if (typeof value !== 'string' || !/^\d{1,2}$/.test(value.trim())) return null;
    var n = +value.trim();
    return n <= MAX_DELIVERY_DAYS ? n : null;
  }
  function isBlank(value) {
    return value === undefined || value === null || (typeof value === 'string' && !value.trim());
  }
  // Comma- or space-separated YYYY-MM-DD dates. Returns null if any date can't be read.
  function parseHolidays(value) {
    var items = Array.isArray(value) ? value : typeof value === 'string' ? value.split(/[\s,]+/) : [];
    var days = [];
    for (var i = 0; i < items.length; i++) {
      if (isBlank(items[i])) continue;
      var dayNum = typeof items[i] === 'number' ? items[i] : parseDateDay(String(items[i]).trim());
      if (dayNum === null || isNaN(dayNum)) return null;
      days.push(dayNum);
    }
    return days;
  }
  function parseSettings(settings) {
    settings = settings || {};
    var timezone = validTimeZone(settings.timezone);
    var cutoffHour = parseCutoffHour(settings.cutoffHour);
    var weekendDays = parseWeekendDays(settings.weekendDays);
    var parsed = {
      timezone: timezone || DEFAULT_SETTINGS.timezone,
      cutoffHour: cutoffHour === null ? DEFAULT_SETTINGS.cutoffHour : cutoffHour,
      weekendDays: weekendDays || DEFAULT_SETTINGS.weekendDays.slice()
    };
    // Optional fields. Left blank, the estimate behaves exactly as it did before they existed.
    // Set but unreadable, they withhold the estimate (the JS-off text stays) rather than fall
    // back to a rule that would show a wrong date.
    var cutoffTime = parseTime(settings.cutoffTime);
    var dayCutoffs = parseDayCutoffs(settings.dayCutoffs);
    var noDispatchDays = parseWeekendDays(settings.noDispatchDays);
    var deliveryDays = parseDeliveryDays(settings.deliveryDays);
    var deliveryDaysMax = parseDeliveryDays(settings.deliveryDaysMax);
    var holidays = parseHolidays(settings.holidays);
    var noDeliveryDates = parseHolidays(settings.noDeliveryDates);
    if (cutoffTime !== null) parsed.cutoffTime = cutoffTime;
    if (dayCutoffs) parsed.dayCutoffs = dayCutoffs;
    if (noDispatchDays) parsed.noDispatchDays = noDispatchDays;
    if (deliveryDays !== null) parsed.deliveryDays = deliveryDays;
    if (deliveryDaysMax !== null && deliveryDaysMax > (deliveryDays || 0)) {
      parsed.deliveryDaysMax = deliveryDaysMax;
    }
    if (holidays && holidays.length) parsed.holidays = holidays;
    if (noDeliveryDates && noDeliveryDates.length) parsed.noDeliveryDates = noDeliveryDates;
    if (settings.invalid ||
        (cutoffTime === null && !isBlank(settings.cutoffTime)) ||
        dayCutoffs === false ||
        (noDispatchDays === null && !isBlank(settings.noDispatchDays)) ||
        (deliveryDays === null && !isBlank(settings.deliveryDays)) ||
        (deliveryDaysMax === null && !isBlank(settings.deliveryDaysMax)) ||
        holidays === null ||
        noDeliveryDates === null) {
      parsed.invalid = true;
    }
    return parsed;
  }

  function cutoffMinutes(config, day) {
    if (config.dayCutoffs && config.dayCutoffs[day] !== undefined) return config.dayCutoffs[day];
    if (config.cutoffTime !== undefined) return config.cutoffTime;
    return config.cutoffHour * 60;
  }
  function isHoliday(config, dayNum) {
    return !!config.holidays && config.holidays.indexOf(dayNum) !== -1;
  }
  function isDispatchDay(config, dayNum) {
    var closed = config.noDispatchDays || config.weekendDays;
    return closed.indexOf(weekday(dayNum)) === -1 && !isHoliday(config, dayNum);
  }
  function isDeliveryDay(config, dayNum) {
    return config.weekendDays.indexOf(weekday(dayNum)) === -1 && !isHoliday(config, dayNum) &&
      !(config.noDeliveryDates && config.noDeliveryDates.indexOf(dayNum) !== -1);
  }
  function nextDay(dayNum, test) {
    for (var i = 1; i <= MAX_SCAN_DAYS; i++) {
      if (test(dayNum + i)) return dayNum + i;
    }
    throw new Error('No open day found');
  }
  function deliverFrom(config, dispatchDay, days) {
    var d = dispatchDay;
    var isOpen = function (n) { return isDeliveryDay(config, n); };
    if (days === 0) return isOpen(d) ? d : nextDay(d, isOpen);
    for (var i = 0; i < days; i++) d = nextDay(d, isOpen);
    return d;
  }
  // Returns { today, first, last } as day numbers; last equals first unless a range is configured.
  function computeDays(now, override, settings) {
    var config = parseSettings(settings);
    var today = dayNumber(now.year, now.month, now.day);
    if (override) {
      var ov = dayNumber(override.getFullYear(), override.getMonth(), override.getDate());
      if (ov >= today) return { today: today, first: ov, last: ov };
    }
    // An explicit store-wide override still shows; otherwise unreadable settings show no date.
    if (config.invalid) throw new Error('Invalid delivery settings');
    var minutes = now.hour * 60 + now.minute;
    var dispatch = isDispatchDay(config, today) && minutes < cutoffMinutes(config, weekday(today))
      ? today
      : nextDay(today, function (n) { return isDispatchDay(config, n); });
    var min = config.deliveryDays || 0;
    var first = deliverFrom(config, dispatch, min);
    var last = config.deliveryDaysMax ? deliverFrom(config, dispatch, config.deliveryDaysMax) : first;
    return { today: today, first: first, last: last };
  }
  function computeTarget(now, override, settings) {
    return toLocalDate(computeDays(partsFromDate(now), override, settings).first);
  }
  function formatLabel(now, target) {
    var diff = Math.round(
      (Date.UTC(target.getFullYear(), target.getMonth(), target.getDate()) -
        Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000
    );
    var prefix = diff === 0 ? 'Today' : diff === 1 ? 'Tomorrow' : DAYS[target.getDay()];
    return prefix + ', ' + MONTHS[target.getMonth()] + ' ' + target.getDate();
  }
  // Short form so a range stays on one line beside the badge text: 'Tue, Oct 6 – Thu, Oct 8'.
  function formatShort(dayNum) {
    var p = dayParts(dayNum);
    return DAYS[weekday(dayNum)].slice(0, 3) + ', ' + MONTHS[p.month].slice(0, 3) + ' ' + p.day;
  }
  function formatDays(days) {
    if (days.last !== days.first) {
      return formatShort(days.first) + ' – ' + formatShort(days.last);
    }
    return formatLabel(toLocalDate(days.today), toLocalDate(days.first));
  }
  function estimateParts(now, overrideStr, settings) {
    return formatDays(computeDays(now, parseOverride(overrideStr), settings));
  }
  function estimate(now, overrideStr, settings) {
    return estimateParts(partsFromDate(now), overrideStr, settings);
  }
  // The store's wall-clock date and time, read without going through the shopper's timezone.
  function getNowParts(timezone) {
    var configuredTimezone = validTimeZone(timezone) || DEFAULT_SETTINGS.timezone;
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: configuredTimezone, year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hour12: false
      }).formatToParts(new Date());
      var g = function (t) { return +parts.find(function (p) { return p.type === t; }).value; };
      var hour = g('hour'); if (hour === 24) hour = 0;
      return { year: g('year'), month: g('month') - 1, day: g('day'), hour: hour, minute: g('minute') };
    } catch (e) {
      return partsFromDate(new Date());
    }
  }
  function getNow(timezone) {
    var p = getNowParts(timezone);
    return new Date(p.year, p.month, p.day, p.hour, p.minute);
  }
  function getDubaiNow() {
    return getNow(DEFAULT_SETTINGS.timezone);
  }
  function render(el) {
    if (!el) return;
    try {
      var settings = parseSettings({
        timezone: el.getAttribute('data-timezone'),
        cutoffHour: el.getAttribute('data-cutoff'),
        weekendDays: el.getAttribute('data-weekend'),
        cutoffTime: el.getAttribute('data-cutoff-time'),
        dayCutoffs: el.getAttribute('data-day-cutoffs'),
        noDispatchDays: el.getAttribute('data-no-dispatch'),
        deliveryDays: el.getAttribute('data-delivery-days'),
        deliveryDaysMax: el.getAttribute('data-delivery-days-max'),
        holidays: el.getAttribute('data-holidays'),
        noDeliveryDates: el.getAttribute('data-no-delivery-dates')
      });
      el.textContent = estimateParts(getNowParts(settings.timezone), el.getAttribute('data-override') || '', settings);
    } catch (e) { /* leave JS-off fallback text in place */ }
  }
  function init() {
    var nodes = document.querySelectorAll('[data-pdpv2-delivery]');
    for (var i = 0; i < nodes.length; i++) render(nodes[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PDPV2DeliveryEstimate = {
    DEFAULT_SETTINGS: DEFAULT_SETTINGS,
    estimate: estimate,
    estimateParts: estimateParts,
    computeTarget: computeTarget,
    computeDays: computeDays,
    parseOverride: parseOverride,
    parseSettings: parseSettings,
    formatLabel: formatLabel,
    getNow: getNow,
    getNowParts: getNowParts,
    getDubaiNow: getDubaiNow,
    render: render
  };
})();
